const slideshowHeadingNodes = document.querySelectorAll('slideshow-component .banner__heading');
if (slideshowHeadingNodes) handleHeadingsCustomColors(slideshowHeadingNodes);

function handleHeadingsCustomColors(slideshowHeadingNodes) {
  slideshowHeadingNodes.forEach(headingNode => {
    const { 
      headingPart1, 
      headingPart2,
      enableCColorHeadingPart1,
      enableCColorHeadingPart2,
    } = headingNode.dataset;
    const bannerClassPart1 = ".banner__heading--first";
    const bannerClassPart2 = ".banner__heading--second";

    if (enableCColorHeadingPart1 === 'true' && headingPart1) setRichTextCustomColors(headingPart1, headingNode, bannerClassPart1);
    if (enableCColorHeadingPart2 === 'true' && headingPart2) setRichTextCustomColors(headingPart2, headingNode, bannerClassPart2);

    function setRichTextCustomColors(headingPartText, headingNode, bannerClass) {
      const regexFindColors = /[^[\]]+(?=])/g;
      const resultMatchGroup = headingPartText.match(regexFindColors); 

      if(resultMatchGroup != null && resultMatchGroup.length > 0) {
        for(let i=0 ; i< resultMatchGroup.length; i++) {
          const color = resultMatchGroup[i].split("/")[0].split("=")[1];
          const word = resultMatchGroup[i].split("/")[1];
          headingPartText = headingPartText.replace(`[${resultMatchGroup[i]}]`, `<span style="color: ${color}">${word}</span>`);
        }
        headingNode.querySelector(bannerClass).innerHTML = headingPartText;
      }
    }
  });
  
}